import cloudflareAssets from "@/assets/cloudflareAssets";
import { CloudflareAsset, Currencies } from "@/shared/common/enums";

export const currencyOptions = [
  {
    label: Currencies.USD,
    meta: cloudflareAssets.USA,
    value: Currencies.USD,
    icon: CloudflareAsset.USA,
  },
  {
    label: Currencies.EUR,
    meta: cloudflareAssets.EUR,
    value: Currencies.EUR,
    icon: CloudflareAsset.EUR,
  },
  {
    label: Currencies.GBP,
    meta: cloudflareAssets.GBR,
    value: Currencies.GBP,
    icon: CloudflareAsset.GBR,
  },
  {
    label: Currencies.AMD,
    meta: cloudflareAssets.ARM,
    value: Currencies.AMD,
    icon: CloudflareAsset.ARM,
  },
  {
    label: Currencies.RUB,
    meta: cloudflareAssets.RUS,
    value: Currencies.RUB,
    icon: CloudflareAsset.RUS,
  },
  {
    label: Currencies.GEL,
    meta: cloudflareAssets.GEL,
    value: Currencies.GEL,
    icon: CloudflareAsset.GEL,
  },
  {
    label: Currencies.JPY,
    meta: cloudflareAssets.JPN,
    value: Currencies.JPY,
    icon: CloudflareAsset.JPN,
  },
  {
    label: Currencies.INR,
    meta: cloudflareAssets.IND,
    value: Currencies.INR,
    icon: CloudflareAsset.IND,
  },
  {
    label: Currencies.CNY,
    meta: cloudflareAssets.CHN,
    value: Currencies.CNY,
    icon: CloudflareAsset.CHN,
  },
  {
    label: Currencies.KRW,
    meta: cloudflareAssets.KOR,
    value: Currencies.KRW,
    icon: CloudflareAsset.KOR,
  },
  {
    label: Currencies.SEK,
    meta: cloudflareAssets.SWE,
    value: Currencies.SEK,
    icon: CloudflareAsset.SWE,
  },
  {
    label: Currencies.CHF,
    meta: cloudflareAssets.CHE,
    value: Currencies.CHF,
    icon: CloudflareAsset.CHE,
  },
  {
    label: Currencies.CAD,
    meta: cloudflareAssets.CAN,
    value: Currencies.CAD,
    icon: CloudflareAsset.CAN,
  },
  {
    label: Currencies.AUD,
    meta: cloudflareAssets.AUS,
    value: Currencies.AUD,
    icon: CloudflareAsset.AUS,
  },
  {
    label: Currencies.AED,
    meta: cloudflareAssets.ARE,
    value: Currencies.AED,
    icon: CloudflareAsset.ARE,
  },
];
